// Custom request headers are stored on the workspace as a name→value map
// (crawlerSettings.customHeaders). The editor works in rows so the user can add,
// remove and reorder; these helpers convert between the two shapes and decide
// which rows are sendable. Header validation itself lives in the backend
// (CustomHeadersValidator); the only rule the editor owns is row completeness.

const isBlank = (s) => String(s ?? "").trim() === "";

const isEmptyRow = (row) => isBlank(row.name) && isBlank(row.value);

// Exactly one of name/value filled. The backend rejects such a header, so the
// editor blocks the save and flags the row rather than silently dropping a
// half-typed value (e.g. a WAF token the user fat-fingered).
export const isIncompleteRow = (row) => isBlank(row.name) !== isBlank(row.value);

export const headersMapToRows = (map = {}) =>
    Object.entries(map || {}).map(([name, value]) => ({ name, value }));

// Drops the fully-empty "clicked Add then changed my mind" rows and builds the
// name→value map to persist. Insertion order is preserved. Assumes any
// incomplete row has already blocked the save (see isIncompleteRow).
export const rowsToHeadersMap = (rows = []) =>
    rows
        .filter((row) => !isEmptyRow(row))
        .reduce((acc, { name, value }) => {
            acc[name] = value;
            return acc;
        }, {});
